import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./UserRecommendations.css";
import "chartjs-adapter-date-fns";

function UserRecommendations() {
  const navigate = useNavigate();
  const [recommendations, setRecommendations] = useState([]);

  //recommendations
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/recommendations`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        setRecommendations(data);
      })
      .catch((error) => console.error("Error fetching user profile:", error));
  }, []);

  return (
    <div className="user-recommendations">
      <h3>Recommendations to Improve Empathy</h3>
      {recommendations && recommendations.length > 0 ? (
        recommendations.map((rec, index) => (
          <div key={index} className="recommendation-item">
            <h4>
              {rec.id} - {rec.heading}
            </h4>
            <p className="recommendation-text">{rec.text}</p>
          </div>
        ))
      ) : (
        <div className="recommendation-item" style={{ textAlign: "center" }}>
          <h4>
            Keep doing what you are doing! At this point, there are no
            recommendations for you to further your empathy.
          </h4>
        </div>
      )}
      <div className="gemini-button-container">
        <button
          onClick={() => {
            if (localStorage.getItem("geminiConsent") === "true") {
              navigate("/gemini-chat");
            } else {
              navigate("/gemini-consent");
            }
          }}
        >
          Ask Gemini about these
        </button>
      </div>
    </div>
  );
}

export default UserRecommendations;